import { CurrencyConversionDto } from 'types/dtos/currency-conversion'

import { CurrencyConversionModel } from 'types/models/currency-conversion'

export const transformCurrencyConversionDto = ({
  seller_currency,
  seller_price,
  seller_shipping_price,
  fx_base_amount,
  fx_rounded_rate,
  fx_markup_rate,
  buyer_currency,
}: CurrencyConversionDto): CurrencyConversionModel => {
  return {
    sellerPrice: seller_price,
    sellerShippingPrice: seller_shipping_price,
    sellerCurrency: seller_currency,
    buyerCurrency: buyer_currency,
    fxRoundedRate: fx_rounded_rate,
    fxBaseAmount: fx_base_amount,
    fxMarkupRate: fx_markup_rate,
  }
}
